import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { mutate } from 'swr';
import { images } from '../../../Constants/ImageUrls';
import {
  convertPrice,
  getCountry,
  uaeString,
} from '../../../Utils/ForeignUtils';
import {
  clickCardEvent,
  clickInstrumentationAddToCart,
} from '../../../Utils/StoreHomePageUtils';
import { removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { useNavigation } from '../../../Utils/navigationUtils';
import {
  addTocartBogoHandler,
  addToCartHandler,
  getCartButton,
} from '../../../Utils/productAction';
import { navigateToCartPage } from '../../../Utils/redirections';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { harcodedTextFlagData } from '../../CategoryDetail/CategoryProductTags/constant';
import { ProductFlag } from '../../CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import { pushAnotherRoute } from '../../Clinic/common';
import { SkeletonBox } from '../../Product/Skeleton/styled';
import {
  ProductNewImageDiv,
  ProductNewImageSection,
  ProductNewMainSection,
} from '../../StoreCategoryPage/SubCategoryProducts/styled';
import { getProductIds, selectProductHandler } from '../BogoClothDiaper/common';
import { fireAddProductEvent } from '../BogoClothDiaper/instrumentation';
import CardButtons from './CardButtons';
import CardContext from './ProductCardContext';
import { ProductCardPrice, ProductPrice, Rating } from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';

function ProductCard(props) {
  const {
    storeHome,
    mobileMaxWidth,
    mobileMinWidth,
    index,
    browse,
    length,
    maxWidth,
    card,
    type,
    setChangeCartCount,
    sectionId,
    sectionName,
    showPrice,
    shrink,
    showRating,
    setOfferCartData,
    offerCartData,
    hideStickyStrip,
    DoubleGrid,
    productList,
    clothDiaper,
    title,
    userType,
    parentIndex,
    showVerticalGrid,
    isForNewCdPage,
  } = props;
  const router = useRouter();
  const [showImagesPopup, setShowImagesPopup] = useState(false);
  const [popupImages, setPopupImages] = useState();
  const [country, setCountry] = useState();
  const { viewAllClickHandler } = useNavigation();
  const [cardEffect, setCardEffect] = useState('');
  const [loaderState, setLoaderState] = useState('');
  const [showLoader, setShowLoader] = useState('');
  const [clickEffect, setClickEffect] = useState('');
  const [showGoToCart, setShowGoToCart] = useState(false);
  const ratingString = card?.starRatingSubScript;
  const data = useGetCartData();
  const ratingText =
    ratingString?.slice(0, ratingString.length - 1) + ' Ratings)';
  let strikePrice = card?.strikePrice || card?.strikeprice;
  if (typeof strikePrice !== 'string') {
    let data = strikePrice;
    strikePrice = `₹${data}`;
  }
  const { price: strikePriceFinal, symbol } = convertPrice(strikePrice);
  useEffect(() => {
    offerCartData?.productList?.map((offerData) => {
      if (offerData?.id === card?.id && offerData?.quantity == 0) {
        setLoaderState('');
      }
    });
  }, [offerCartData]);
  const webUrl = card?.cardView
    ? card?.deeplinkValue
    : card?.webUrl || card?.web_url;
  const productId = card?._id || card?.id;
  const productPriceFinal =
    typeof card?.price === 'string' ? card?.price : `₹${card?.price}`;
  const { price: PriceFinal } = convertPrice(productPriceFinal);
  const productNameFinal = offerCartData?.productList
    ? card?.variantType
    : card?.name;

  const productFlagData = card?.textFlag || harcodedTextFlagData;

  const clickHandler = (e) => {
    if (clothDiaper) {
      e.preventDefault();
      AddProductHandler();
    } else {
      card?.cardView
        ? viewAllClickHandler(card?.deeplinkValue)
        : productClickHandler(productId, card, type, e);
    }
  };
  useEffect(() => {
    if (getCartButton(parseInt(productId)) === 2) {
      setShowGoToCart(true);
    } else {
      setShowGoToCart(false);
    }
  }, [router.query]);
  const productClickHandler = async (product_id, card, viewType, e) => {
    e.preventDefault();

    if (offerCartData?.productList && !hideStickyStrip) {
      const diaperOfferData = await selectProductHandler(
        product_id,
        offerCartData,
      );
      setOfferCartData(diaperOfferData?.data);
      setShowImagesPopup(true);
      pushAnotherRoute('bogoPopup', router);
    } else if (clothDiaper) {
      const diaperOfferData = await selectProductHandler(
        product_id,
        productList,
      );
      setPopupImages(diaperOfferData?.data);
      clickCardEvent(card, product_id, viewType, card?.nickname, {
        itemId: sectionId,
        heading: sectionName,
        position: parentIndex,
      });
      setShowImagesPopup(true);
      pushAnotherRoute('bogoPopup', router);
    } else {
      setCardEffect('lowOpacity');
      setTimeout(async () => {
        const value = webUrl;
        setCardEffect('');
        const { addParams, newUrl } = queryParamHandling(value);

        router.push(newUrl + addParams, '', {
          locale: getRouterLocale(router),
        });
        clickCardEvent(card, {
          itemId: sectionId,
          heading: sectionName,
          position: parentIndex,
        });
      }, 200);
    }
  };
  const getDesktopImage = (product) => {
    return product?.image || product?.showImage;
  };
  useEffect(() => {
    setCountry(getCountry());
  }, []);
  const getMobileImage = (product) => {
    return product?.image || product?.showImage;
  };

  const getDiscountPercent = (price, strikeprice) => {
    if (price && strikeprice) {
      if (price === strikeprice) return;
      const discount = Math.floor(((strikeprice - price) / strikeprice) * 100);
      return `${discount}% Off`;
    }
  };
  const srcSetUrl = `${getMobileImage(
    card,
  )}?tr=w-200,q-90 200w, ${getDesktopImage(card)}?tr=w-400,q-90 400w`;
  const cardButtonsProps = {
    hideStickyStrip: hideStickyStrip,
    offerCartData: offerCartData,
    productData: card,
    setChangeCartCount: setChangeCartCount,
    setOfferCartData: setOfferCartData,
    sectionName: sectionName,
    sectionId: sectionId,
    showImagesPopup: showImagesPopup,
    setShowImagesPopup: setShowImagesPopup,
    popupImages: popupImages,
    setPopupImages: setPopupImages,
    loaderState: loaderState,
    setLoaderState: setLoaderState,
    showLoader: showLoader,
    setShowLoader: setShowLoader,
  };
  const clickedAddToCart = async () => {
    if (data) {
      await mutate('/api/getNewCartAmountOfUserWeb', null, false);
    }
    setLoaderState('loading');
    clickInstrumentationAddToCart(
      'clicked_add_to_cart',
      undefined,
      card,
      sectionName,
      sectionId,
    );
    const addedToCart = await addToCartHandler(productId);
    setLoaderState('loaded');
    if (addedToCart) {
      setTimeout(() => {
        setShowGoToCart(true);
        setChangeCartCount(true);
      }, 800);
    }
    // }
  };

  const multipleProductHandler = async () => {
    setLoaderState('loading');
    setLoaderState('loaded');

    const productId = card?.id || card?._id;
    const offerCode = offerCartData?.offerData?.offerCode;
    fireAddProductEvent(card, productId, offerCode);
    const params = {
      productId: productId,
      ids: getProductIds(offerCartData?.productList),
      add: false,
      less: false,
      addToCart: true,
      selectedProductId: productId,
    };
    if (setChangeCartCount) {
      setChangeCartCount(true);
    }
    const data = await addTocartBogoHandler(params);
    setOfferCartData(data?.data);

    if (card?.quantity > 0) {
      setShowLoader('+');
    }
    setTimeout(() => {
      setShowLoader('');
    }, 600);
  };
  const goToCartClickHandler = () => {
    clickInstrumentationAddToCart(
      'clicked_go_to_cart',
      undefined,
      card,
      sectionName,
      sectionId,
    );
    //redirectToMyloUrl("/cart");
    navigateToCartPage();
  };
  const AddProductHandler = async () => {
    if (clothDiaper) {
      setClickEffect('lowOpacity');

      if (hideStickyStrip) {
        if (showGoToCart) {
          goToCartClickHandler();
        } else {
          clickedAddToCart();
        }
      } else {
        multipleProductHandler();
      }
      setTimeout(() => {
        setClickEffect('');
      }, 300);
    }
  };
  const getIdForSection = () => {
    const startId = title ? `0${title}` : `0first`;
    const lastId = title ? `${title}last` : `${length - 1}last`;

    return index == 0
      ? startId
      : index == length - 1
        ? lastId
        : `productCards${index}`;
  };
  return (
    <>
      <ProductNewMainSection
        className={`hoverable_section ${cardEffect}`}
        id={getIdForSection()}
        card={card?.cardView}
        maxWidth={maxWidth}
        browse={browse}
        shrink={shrink}
        storeHome={storeHome}
        mobileMaxWidth={mobileMaxWidth}
        mobileMinWidth={mobileMinWidth}
        DoubleGrid={DoubleGrid}
        showVerticalGrid={showVerticalGrid}
        key={`product_${index}`}
        isForNewCdPage={isForNewCdPage}
      >
        <div className="animated_card">
          <Link
            href={{
              pathname: webUrl,
              query: removeDefaultParams(router.query),
            }}
            passHref
            locale={false}
            legacyBehavior
          >
            <LazyLoad height={100} once offset={100}>
              <ProductNewImageSection
                DoubleGrid={DoubleGrid}
                onClick={(event) => clickHandler(event)}
              >
                <ProductNewImageDiv
                  // lastImage={
                  //     card?.itemType == "BANNER"
                  // }
                  home
                >
                  {index < 3 && clothDiaper && (
                    <ProductFlag>
                      {`Bestseller #${index + 1}`}
                      <span></span>
                    </ProductFlag>
                  )}
                  <Image
                    className={clickEffect}
                    src={getMobileImage(card)}
                    alt={productNameFinal}
                    loading="lazy"
                    quality={90}
                    title={productNameFinal}
                    fill
                    sizes="50vw"
                  />

                  {isForNewCdPage && (
                    <button
                      className="view-360-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        let view360Path;
                        switch (productNameFinal) {
                          case 'Floral Spring':
                            view360Path = '/store/view-in-room/floral';
                            break;
                          case 'Rainbow':
                            view360Path = '/store/view-in-room/rainbow';
                            break;
                          case 'Twinkle Twinkle':
                            view360Path = '/store/view-in-room/star';
                            break;
                          case 'Pet Love Print':
                            view360Path = '/store/view-in-room/pet-love';
                            break;
                          case 'Heart Doodles':
                            view360Path = '/store/view-in-room/heart-doodle';
                            break;
                          default:
                            view360Path = '/store/view-in-room/';
                        }
                        router.push(view360Path);
                      }}
                    >
                      View 360°
                    </button>
                  )}
                </ProductNewImageDiv>
              </ProductNewImageSection>
            </LazyLoad>
          </Link>

          <ProductCardPrice DoubleGrid={DoubleGrid}>
            {card?.cardView ? (
              <div></div>
            ) : (
              <div>
                <Link
                  href={{
                    pathname: webUrl,
                    query: removeDefaultParams(router.query),
                  }}
                  locale={false}
                  passHref
                  onClick={(event) => clickHandler(event)}
                >
                  <div>
                    <div className="product_name">{productNameFinal}</div>
                    {/* {clothDiaper && userType === "B" ? (
                                            <IdealForText>
                                                {"(Ideal for: 3M-3Yrs)"}
                                            </IdealForText>
                                        ) : null} */}
                    <ProductPrice
                      DoubleGrid={DoubleGrid}
                      isUAE={country === uaeString}
                    >
                      {!offerCartData?.productList ? (
                        showPrice ? (
                          <>
                            <span
                              className={
                                country === uaeString
                                  ? 'uaeAmountPrice'
                                  : 'totalAmount'
                              }
                            >
                              {symbol}
                              {PriceFinal}
                            </span>
                            {strikePriceFinal && strikePriceFinal != '0' ? (
                              <span
                                className={
                                  country === uaeString
                                    ? 'uaeStrikePrice'
                                    : 'strikePrice'
                                }
                              >
                                {symbol}

                                {strikePriceFinal}
                              </span>
                            ) : null}

                            <span className="discount">
                              {card?.discount ||
                                getDiscountPercent(
                                  card?.price,
                                  card?.strikeprice,
                                )}
                            </span>
                          </>
                        ) : (
                          <SkeletonBox height="20px" width="150px" />
                        )
                      ) : null}
                    </ProductPrice>

                    {!showRating && showRating != undefined
                      ? null
                      : card?.starRating > 0 && (
                          <Rating DoubleGrid={DoubleGrid}>
                            <span>{card?.starRating}</span>
                            <img
                              src={images.filledStar}
                              alt="filledStar"
                              title="filledStar"
                            />
                            <span className="total_ratingnumber">
                              {ratingText}
                            </span>
                          </Rating>
                        )}
                  </div>
                </Link>

                <CardContext.Provider value={cardButtonsProps}>
                  <CardButtons isForNewCdPage={isForNewCdPage} />
                </CardContext.Provider>
              </div>
            )}
          </ProductCardPrice>
        </div>
      </ProductNewMainSection>
    </>
  );
}

export default ProductCard;
